module.exports = __webpack_public_path__ + "img/couples_10_V.2f0e3ec9.jpg";